import * as React from "react";
import { jsx as _jsx } from "react/jsx-runtime";
const SvgLogo = (props) => /* @__PURE__ */ _jsx("svg", {
	width: 44,
	height: 44,
	viewBox: "0 0 44 44",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	...props,
	children: /* @__PURE__ */ _jsx("path", {
		fillRule: "evenodd",
		clipRule: "evenodd",
		d: "M32.4955 33.3835L24.8209 41L5.67139 22L14.0096 13.7286L21.6801 21.341C21.3466 21.6691 21.2882 22.2662 21.6815 22.6591L32.4955 33.3835ZM24.8217 3.00314L32.5533 10.6728L30.7405 12.468L23.0116 4.79834L24.8217 3.00314ZM19.8706 2.9997L12.196 10.6135L23.0107 21.3427C23.372 21.7005 23.3831 22.2885 23.0107 22.6587L30.6826 30.2711L39.0208 21.9997L19.8706 2.9997ZM19.8716 40.9972L12.1414 33.3276L13.9556 31.5275L21.6831 39.1978L19.8716 40.9972Z",
		fill: "current"
	})
});
export default SvgLogo;
